import {ProgramIncrement} from '../programIncrement';

export class MpcBoardConfiguration {
  public id: number;
  public programKey: number;
  public visibleTeams: string[] = [];
  public teams: string[] = [];
  public sprints: string[] = [];

  constructor(
    id: number,
    programKey: number,
    visibleTeams: string[],
    teams: string[],
    sprints: string[]
  ) {
    this.id = id;
    this.programKey = programKey;
    this.visibleTeams = visibleTeams;
    this.teams = teams;
    this.sprints = sprints;
  }

  addTeam(teamKey: string) {
    this.teams.push(teamKey);
    this.visibleTeams.push(teamKey);
  }

  removeTeam(teamKey: string) {
    const index = this.visibleTeams.findIndex(visTeamKey => visTeamKey === teamKey);
    if (index > -1) {
      // only remove from visible teams
      this.visibleTeams.splice(index, 1);
    }
  }

  setTeamVisible(teamKey: string) {
    const indexVis = this.visibleTeams.findIndex(visTeamKey => visTeamKey === teamKey);
    const indexTeam = this.teams.findIndex(tKey => tKey === teamKey);
    if (indexTeam > -1 && indexVis === -1) {
      this.visibleTeams.push(teamKey);
    }
  }
}
